import Model from '../models/model';
import connectionService from '../services/Connection';

const loadUsers = async ({ keyword }) => {
	if (!keyword) {
		return { options: [], count: 0 };
	}
	const formData = new FormData();
	formData.append('asArray', '0');
	formData.append('start', '0');
	formData.append('limit', 50);
	formData.append('excludeGenericUsers', true);
	formData.append('excludeDepartment', true);
	formData.append('canReviewed', true);
	formData.append('comboType', 'User');
	const { options, count } = await fetch(connectionService.Combo, {
		method: 'POST',
		body: formData
	})
		.then((res) => res.json())
		.then((json) => {
			const { records } = json;
			let options = records?.map((record) => ({
				id: record.LookupId,
				label: record.DisplayValue,
				...record
			}));
			if (!Array.isArray(options)) {
				options = [];
			}
			return { options: options || [], count: options?.length };
		});
	return { options, count };
};

const model = new Model({
	name: 'Cycle',
	api: 'Cycle',
	title: 'Cycle',
	disableDelete: true,
	showGridRefreshBtn: true,
	customizeSaveData: (values) => {
		values.action = 'otherAction';
		values.otherAction = 'ApproveCycle';
		return values;
	},
	formGroups: [
		{
			fields: ['selected', 'statusId', 'reviewerId', 'password', 'barcode', 'comment'],
			fieldProps: {
				inlineLabelSize: 12
			}
		}
	],
	columns: [
		{ header: 'Username', field: 'reviewerId', lookup: loadUsers, filterMode: 'server', required: true },
		{
			header: 'Status',
			field: 'statusId',
			lookup: 'CycleActionStatus',
			inputWhen: ({ activeRecord }) => !activeRecord?.record?.statusId
		},
		{
			header: 'Cycle',
			field: 'selected',
			lookup: 'Cycle',
			inputWhen: ({ activeRecord }) => !activeRecord?.record?.selected
		},
		{
			header: 'Password',
			field: 'password',
			type: 'password',
			skipPasswordStrengthCheck: true,
			required: [{ field: 'barcode', op: ({ value }) => !value }]
		},
		{
			header: 'Barcode',
			field: 'barcode',
			required: [{ field: 'password', op: ({ value }) => !value }]
		},
		{
			header: 'Comment',
			field: 'comment',
			required: true,

			inputProps: {
				rows: 2,
				multiline: true
			}
		}
	]
});
export const CycleReviewForm = model.createFormDialog();
export default model.createFormBase();
